import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    searchItem: "",
    searchSite: "",
    isHotShipment: false,
    isTempControlled: false,
    shipmentMode: "",
    materialTypes: {
      finishedGoods: false,
      components: false,
    },
  },
};

const globalFilterSlice = createSlice({
  name: "globalFilter",
  initialState,
  reducers: {
    setGlobalFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetGlobalFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setGlobalFilters, resetGlobalFilters } = globalFilterSlice.actions;
export default globalFilterSlice.reducer;